<template>
	<div>
		<headers></headers>
		<div v-if="showtype=='1'" class="p-sm-5 flex wrap">
			<div style="width: 60%;">
				<h3 class="ftw600">{{'我們只專注提供'}}</h3>
				<h3 class="cl-theme ftw600">{{'網上一對一補習的平台'}}</h3>
				<div class="ft16">
					{{'打破傳統補習模式，讓學生擁有更多時間，改變學習生態！'}}
				</div>

				<div class="cl-theme mt-3 ftr-1-25 ftw600">
					{{'關於 MiraStudent ：'}}
				</div>
				<div class="ft16 mt-3">
					{{'MiraStudent 由Mira Talker Limited創立，是一家扎根香港的教育m科技服務企業。我們的名字“Mira”源自“Miracle”（奇蹟），我們深信每一個學生，無論背景，都有享受最優質教育的權利和機會，我們希望通過MiraStudent來實現這教育奇蹟。'}}
				</div>
				<div class="ft16 mt-3">
					{{'有否想過，你的子女平均每天花費超過1-2小時在往返補習社的路上，而疲倦和飢餓感令他們沒法專注上堂，而群體學習，亦減少互動和發問的機會，未能針對他們的學習需求和問題。其實這些時間本可用於高效學習、發展興趣，或與家人共處。'}}
					
				</div>
				<div class="ft16 mt-3">
					{{'MiraStudent 正是為了改變這生態而生——我們通過科技與教育結合，打造高效、靈活、專注、互動的一對一網上補習平台，幫助學生奪回時間，專注互動學習，輕鬆應付考試。'}}
				</div>
				
			</div>
			<div class="flex center" style="flex: 1;">
				<img src="../../assets/image/textContent/aboutUs.png" alt="" style="width:60%;" />
			</div>
		</div>
		<div v-else class="p-sm-5" >
			<h3 class="cl-theme ftw600">{{'我們的願景（Vision）'}}</h3>
			<h3 class="ftw600">{{'"我們致力成為香港最專業且普及網上補習平台，讓每個學生無論身處何地、資源多少，都能享受優質、個性化的教育，提升學習效率和考試成績。”'}}</h3>
			<h3 class="cl-theme ftw600 mt-5">{{'我們的使命（Missions）'}}</h3>
			
			<div class="mt-3 ft16 ftw600">
				{{'提供專業師資與個性化教學'}}
			</div>
			<div class="mt-2">
				嚴格篩選老師團隊，包括前名校教師、註冊教師、公開試考官及海外教育專家，提供專科專教的一對一網上補習。涵蓋呈分試、DSE、IB、iGCSE、A-Level等公開試，因材施教，幫助學生高效攻克難題、掌握應試技巧，提升考試表現。
			</div>
			<div class="mt-3 ft16 ftw600">
				{{'以科技成就真實的補習體驗'}}
			</div>
			<div class="mt-2">
				運用人工智能配對系統，根據學生需要精準匹配老師；結合視訊工具與即時筆記軟體，營造專注互動的課堂體驗。每堂課後提供詳細課堂報告，讓家長清楚了解學生進度，見證實質進步。
			</div>
			<div class="mt-3 ft16 ftw600">
				{{'推動教育平等與社會共融'}}
			</div>
			<div class="mt-2">
				我們承諾將部分收益投入慈善公益，資助基層及特殊學習需要的學生，推動教育公平，讓弱勢社群都能享有優質教育資源。
			</div>
			<div class="mt-3 ft16 ftw600">
				{{'培養學生綜合能力和關注身心健康'}}
			</div>
			<div class="mt-2">
				除了提升學業成績，我們同時重視學生的思維能力、適應力與國際視野，促進全面發展。網上學習亦讓學生有更多休息時間，減輕壓力，關注身心健康。
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			showtype: '1'
		},
		created() {
			this.showtype = this.$route.query.type
		},
		methods: {

		}
	}
</script>

<style>
</style>